import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_replenishment_tasks_grid_ComponentContextService } from './FootprintManager.replenishment_tasks_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Inventory_task_statuses_dd_multiComponent } from './Inventory.task_statuses_dd_multi.component'


interface IFootprintManager_replenishment_tasks_gridComponentEntity {
  Id?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, ExpectedPackagedAmount?: number, ModifiedSysUser?: string, Notes?: string, SerialNumberId?: number, ActualPackagedPack?: { ShortName?: string }, ExpectedPackagedPack?: { ShortName?: string }, Lot?: { Id?: number, LookupCode?: string, Material?: { ProjectId?: number } }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number }, Project?: { Id?: number, LookupCode?: string }, OperationCode?: { Name?: string }, Status?: { Name?: string }, ActualSourceLicensePlate?: { Id?: number, LookupCode?: string }, ActualSourceLocation?: { Id?: number, Name?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string }, ActualTargetLocation?: { Id?: number, Name?: string }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string }, ExpectedTargetLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedTargetLocation?: { Id?: number, Name?: string }, Warehouse?: { Name?: string }}

interface IFootprintManager_replenishment_tasks_gridComponentInParams {
  materialIds?: number[], projectId?: number, locationIds?: number[], ownerId?: number, warehouseIds?: number[]}


class FootprintManager_replenishment_tasks_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_replenishment_tasks_gridComponent;
  entity: IFootprintManager_replenishment_tasks_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    warehouse: null,
    status: null,
    material_lookupcode: null,
    lot: null,
    project: null,
    expected_packaged_amount: null,
    expected_packaging: null,
    actual_packaged_amount: null,
    actual_packaging: null,
    created_date: null,
    expected_target_location: null,
    expected_target_licenseplate: null,
    expected_source_location: null,
    expected_source_licenseplate: null,
    actual_source_licenseplate: null,
    actual_source_location: null,
    actual_target_licenseplate: null,
    actual_target_location: null,
    completed_date: null,
    user: null,
    notes: null,
  }



  constructor(
    grid: FootprintManager_replenishment_tasks_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material_lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.expected_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.expected_packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.actual_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.actual_packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_target_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_target_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_target_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_target_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_source_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_source_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_source_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_source_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_source_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_source_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_source_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_source_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_target_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_target_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_target_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_target_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.completed_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.completed_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.user = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.user,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_replenishment_tasks_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_replenishment_tasks_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      materialIds:  $grid.inParams.materialIds ,
      locationIds:  $grid.inParams.locationIds ,
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      warehouseIds:  $grid.inParams.warehouseIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      statusIds:  $grid.filters.task_status.control.value ,
    };
    const data = await this.$datasources.Replenishments.ds_replenishment_tasks_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_replenishment_tasks_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse.Name;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.material_lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.project.displayControl as TextModel).text = $row.entity.Project?.LookupCode;
    (this.cells.expected_packaged_amount.displayControl as TextModel).text = $row.entity.ExpectedPackagedAmount?.toString();
    (this.cells.expected_packaging.displayControl as TextModel).text = $row.entity.ExpectedPackagedPack?.ShortName;
    (this.cells.actual_packaged_amount.displayControl as TextModel).text = $row.entity.ActualPackagedAmount?.toString();
    (this.cells.actual_packaging.displayControl as TextModel).text = $row.entity.ActualPackagedPack?.ShortName;
    (this.cells.expected_target_location.displayControl as TextModel).text = $row.entity.ExpectedTargetLocation?.Name;
    (this.cells.expected_target_licenseplate.displayControl as TextModel).text = $row.entity.ExpectedTargetLicensePlate?.LookupCode;
    (this.cells.expected_source_location.displayControl as TextModel).text = $row.entity.ExpectedSourceLocation?.Name;
    (this.cells.expected_source_licenseplate.displayControl as TextModel).text = $row.entity.ExpectedSourceLicensePlate?.LookupCode;
    (this.cells.actual_source_licenseplate.displayControl as TextModel).text = $row.entity.ActualSourceLicensePlate?.LookupCode;
    (this.cells.actual_source_location.displayControl as TextModel).text = $row.entity.ActualSourceLocation?.Name;
    (this.cells.actual_target_licenseplate.displayControl as TextModel).text = $row.entity.ActualTargetLicensePlate?.LookupCode;
    (this.cells.actual_target_location.displayControl as TextModel).text = $row.entity.ActualTargetLocation?.Name;
    (this.cells.user.displayControl as TextModel).text = $row.entity.ModifiedSysUser;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'material_lookupcode' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'project' : {
        this.on_project_clicked();
        break;
      }
      case 'expected_target_location' : {
        this.on_expected_target_location_clicked();
        break;
      }
      case 'expected_target_licenseplate' : {
        this.on_expected_target_lp_clicked();
        break;
      }
      case 'expected_source_location' : {
        this.on_expected_source_location_clicked();
        break;
      }
      case 'expected_source_licenseplate' : {
        this.on_expected_source_lp_clicked();
        break;
      }
      case 'actual_source_licenseplate' : {
        this.on_actual_source_lp_clicked();
        break;
      }
      case 'actual_source_location' : {
        this.on_actual_source_location_clicked();
        break;
      }
      case 'actual_target_licenseplate' : {
        this.on_actual_target_lp_clicked();
        break;
      }
      case 'actual_target_location' : {
        this.on_actual_target_location_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Apply date format
  if ($utils.isDefined($row.entity.CreatedSysDateTime) && $utils.isDefined($settings.FootprintManager.DateFormat)) {
      var dateFormat = $settings.FootprintManager.DateFormat;
      var createdDate = $utils.date.format($row.entity.CreatedSysDateTime, dateFormat);
      $row.cells.created_date.displayControl.text = createdDate;
  }
  
  
  if ($utils.isDefined($row.entity.CompletedDateTime) && $utils.isDefined($settings.FootprintManager.DateFormat)) {
      var dateFormat = $settings.FootprintManager.DateFormat;
      var completedDate = $utils.date.format($row.entity.CompletedDateTime, dateFormat);
      $row.cells.completed_date.displayControl.text = completedDate;
  }
  
  
  
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Material_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_material_hub({ materialId: $row.entity.Material.Id });
  }
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Lot_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_lot_hub({ lotId: $row.entity.Lot.Id });
  }
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  if (await $operations.FootprintManager.Disable_Project_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      const projectId = $utils.isDefined($row.entity.Project.Id) ? $row.entity.Project.Id :
          ($utils.isDefined($row.entity.Material.ProjectId) ? $row.entity.Material.ProjectId : $row.entity.Lot?.Material?.ProjectId);
  
  
      if ($utils.isDefined(projectId)) {
          $shell.FootprintManager.opensingle_project_hub({ projectId: $row.entity.Lot.Material.ProjectId });
      }
      else {
          throw new Error('Unable to determine project from the given task.')
      }
  
  }
  }
  on_actual_source_lp_clicked(event = null) {
    return this.on_actual_source_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_lp_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_LicensePlate_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ActualSourceLicensePlate.Id });
  }
  }
  on_actual_target_lp_clicked(event = null) {
    return this.on_actual_target_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_lp_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_LicensePlate_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ActualTargetLicensePlate.Id });
  }
  }
  on_expected_source_lp_clicked(event = null) {
    return this.on_expected_source_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_lp_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_LicensePlate_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ExpectedSourceLicensePlate.Id });
  }
  }
  on_expected_target_lp_clicked(event = null) {
    return this.on_expected_target_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_lp_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_LicensePlate_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ExpectedTargetLicensePlate.Id });
  }
  }
  on_actual_source_location_clicked(event = null) {
    return this.on_actual_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_location_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualSourceLocation.Id });
  }
  }
  on_actual_target_location_clicked(event = null) {
    return this.on_actual_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_location_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualTargetLocation.Id });
  }
  }
  on_expected_source_location_clicked(event = null) {
    return this.on_expected_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_location_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedSourceLocation.Id });
  }
  }
  on_expected_target_location_clicked(event = null) {
    return this.on_expected_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_location_clickedInternal(
    $row: FootprintManager_replenishment_tasks_gridComponentRowModel,
  $grid: FootprintManager_replenishment_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if (await $operations.FootprintManager.Disable_Location_View.isAuthorized()) {
      await $shell.FootprintManager.openInfoDialog('Authorization', 'You are not authorized for this operation.');
  } else {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedTargetLocation.Id });
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Inventory_task_statuses_dd_multiComponent),
  ],
  selector: 'FootprintManager-replenishment_tasks_grid',
  templateUrl: './FootprintManager.replenishment_tasks_grid.component.html'
})
export class FootprintManager_replenishment_tasks_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_replenishment_tasks_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_replenishment_tasks_gridComponentInParams = { materialIds: [], projectId: null, locationIds: [], ownerId: null, warehouseIds: [] };


  //#region Variables
  vars: { suppressConfirmationPrompts?: boolean } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       material_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'material_lookupcode', 'Material', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       expected_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'expected_packaged_amount', 'Expected', false, false, null, false),       expected_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'expected_packaging', 'Expected packaging', false, false, null, false),       actual_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'actual_packaged_amount', 'Actual', false, false, null, false),       actual_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'actual_packaging', 'Actual packaging', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created date', false, false, null, false),       expected_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'expected_target_location', 'Expected target loc', false, false, null, false),       expected_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'expected_target_licenseplate', 'Expected target LP', false, false, null, false),       expected_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'expected_source_location', 'Expected source loc', false, false, null, false),       expected_source_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'expected_source_licenseplate', 'Expected source LP', false, false, null, false),       actual_source_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'actual_source_licenseplate', 'Actual source LP', false, false, null, false),       actual_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'actual_source_location', 'Actual source loc', false, false, null, false),       actual_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'actual_target_licenseplate', 'Actual target LP', false, false, null, false),       actual_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'actual_target_location', 'Actual target loc', false, false, null, false),       completed_date: new GridHeaderModel(new HeaderStyles(null, null), 'completed_date', 'Completed date', false, false, null, false),       user: new GridHeaderModel(new HeaderStyles(null, null), 'user', 'User', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_replenishment_tasks_gridComponentRowModel[] = [];

  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('locationIds') set $inParams_locationIds(value: any) {
    this.inParams['locationIds'] = value;
  }
  get $inParams_locationIds(): any {
    return this.inParams['locationIds'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }

  topToolbar = {
      cancel_button: new ToolModel(new ButtonModel('cancel_button', new ButtonStyles(null, null), false, false, false, 'Cancel', 'icon-ic_fluent_dismiss_circle_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    task_status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    task_status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['task_status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Replenishment tasks';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;

    (this.filters.task_status.control as SelectBoxModel).reset([1]);

    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      materialIds:  $grid.inParams.materialIds ,
      locationIds:  $grid.inParams.locationIds ,
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      warehouseIds:  $grid.inParams.warehouseIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      statusIds:  $grid.filters.task_status.control.value ,
    };
    try {
      const data = await this.$datasources.Replenishments.ds_replenishment_tasks_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_replenishment_tasks_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_replenishment_tasks_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_replenishment_tasks_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_replenishment_tasks_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length > 0) {
      for (let row of $grid.selectedRows) {
          if (row.cells.status.displayControl.text == 'Completed' || row.cells.status.displayControl.text == 'Cancelled') {
              var includesCancelledorCompleted = true
          }
      }
      if (includesCancelledorCompleted) {
          $grid.topToolbar.cancel_button.control.readOnly = true
      }
      else {
          $grid.topToolbar.cancel_button.control.readOnly = false
      }
  } else {
      $grid.topToolbar.cancel_button.control.readOnly = true
  }
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $grid: FootprintManager_replenishment_tasks_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  try {
      let title: string;
      let message: string;
  
      if ($grid.selectedRows.length === 1) {
          title = 'Cancel replenishment task';
          message = `Are you sure you want to cancel the selected replenishment task?`
      }
      else {
          title = 'Cancel replenishment tasks';
          message = `Are you sure you want to cancel the selected replenishment tasks?`;
      }
  
      if (!$grid.vars.suppressConfirmationPrompts) {
          var isConfirm = await $shell.Replenishments.openConfirmationDialog(title, message, 'Confirm', 'Cancel');
      }
      else {
          isConfirm = true;
      }
  
      $grid.vars.suppressConfirmationPrompts = true;
  
      if (isConfirm) {
          // Cancel replenishment tasks
          let result = (await $flows.Replenishments.cancel_replenishment_task_flow({ taskIds: $grid.selectedRows.map(r => r.entity.Id) }));
  
          // Notify user
          if ($utils.isDefined(result.reasons)) {
              throw new Error(result.reasons.join(', '));
          }
          else {
              await $shell.Replenishments.openInfoDialog('Success', 'Successfully cancelled replenishment tasks.');
          }
          for (let row of $grid.selectedRows) {
              row.selected = false;
          }
          await $grid.refresh();
          $grid.selectedRows = [];
      }
  }
  catch (exception) {
      await $shell.Replenishments.openErrorDialog('Error cancelling replenishment task', $utils.isDefined(exception?.error?.error) ? exception.error.error.message : exception.message);
  }
  
  $grid.vars.suppressConfirmationPrompts = false;
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_replenishment_tasks_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_replenishment_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.cancel_button.control.readOnly = true
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
